export default __webpack_public_path__ + "static/Oxygen-SMSF-Fact-Sheet-2-November-2022-533ee338b83208a3bce6d9aa5d1de888.pdf";